import { createSaga } from './saga-helpers';

import * as Api from '../api/time-tracking-api';

const watchGetTimeEntries = createSaga({
    type: 'TIME_ENTRIES_FETCH',
    fn: Api.fetchTimeEntries,
    args: action => [action.payload],
    successPayload: ({ records, hasMore }, action) => ({
        timeEntries: records,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchCreateTimeEntry = createSaga({
    type: 'TIME_ENTRY_CREATE',
    fn: Api.createTimeEntry,
    args: action => [action.payload.timeEntry],
    successPayload: ({ timer_id: timeEntryId }, action) => ({
        timeEntryId,
        fragment: action.payload.timeEntry
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.timeEntry
    })
});

const watchStartTimeEntry = createSaga({
    type: 'TIME_ENTRY_START',
    fn: Api.startTimeEntry,
    args: action => [action.payload.timeEntry],
    successPayload: ({ timer_id: timeEntryId }, action) => ({
        timeEntryId,
        fragment: action.payload.timeEntry
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.timeEntry
    })
});

const watchGetTimeEntry = createSaga({
    type: 'TIME_ENTRY_FETCH',
    fn: Api.fetchTimeEntry,
    args: action => [action.payload.timeEntryId],
    successPayload: timeEntry => ({ timeEntry })
});

const watchStopTimeEntry = createSaga({
    type: 'TIME_ENTRY_STOP',
    fn: Api.stopTimeEntry,
    args: action => [action.payload.timeEntryId],
    successPayload: timeEntry => ({ timeEntry })
});

const watchUpdateTimeEntry = createSaga({
    type: 'TIME_ENTRY_UPDATE',
    fn: Api.updateTimeEntry,
    args: action => [action.payload.timeEntryId, action.payload.timeEntryProps],
    successPayload: timeEntry => ({ timeEntry })
});

const watchRemoveTimeEntry = createSaga({
    type: 'TIME_ENTRY_REMOVE',
    fn: Api.removeTimeEntry,
    args: action => [action.payload.timeEntryId]
});

const sagas = [watchGetTimeEntries, watchCreateTimeEntry, watchStartTimeEntry, watchGetTimeEntry, watchStopTimeEntry, watchUpdateTimeEntry, watchRemoveTimeEntry];

export default sagas;
